import { render, staticRenderFns } from "./CandidateReview.vue?vue&type=template&id=60ed7c7b&scoped=true"
import script from "./CandidateReview.vue?vue&type=script&lang=js"
export * from "./CandidateReview.vue?vue&type=script&lang=js"
import style0 from "./CandidateReview.vue?vue&type=style&index=0&id=60ed7c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed7c7b",
  null
  
)

export default component.exports